//----------------------------------
// Private Variables
//----------------------------------
const statusMapping = {
  open: ['transfer', 'delete'],
  progress: ['transfer', 'download', 'delete'],
  progress_complete: ['review', 'close', 'transfer', 'download', 'delete'],
  reviewing: ['returnReview', 'download'],
  reviewed: ['review', 'close', 'transfer', 'download', 'delete'],
  finished: ['reopen', 'transfer', 'download', 'delete'],
  closed: ['reopen', 'archive', 'transfer', 'download', 'delete'],
  archived: ['reopen', 'download', 'transfer', 'delete'],
};
const actions = [
  { action: 'review', label: 'Überprüfen lassen', icon: 'review', disabled: true },
  { action: 'returnReview', label: 'Retournieren', icon: 'returnReview', disabled: true },
  { action: 'close', label: 'Abschliessen', icon: 'finalize', disabled: true },
  { action: 'archive', label: 'Archivieren', icon: 'archive', disabled: true },
  { action: 'reopen', label: 'Wiedereröffnen', icon: 'reopen', disabled: true },
  { action: 'transfer', label: 'Umteilen', icon: 'transfer', disabled: true },
  { action: 'download', label: 'Herunterladen', icon: 'download', disabled: true },
  { action: 'delete', label: 'Löschen', icon: 'delete', disabled: true },
];

export default class InquiryActions {
  static byStatus(status) {
    const out = JSON.parse(JSON.stringify(actions));
    const enabledActions = statusMapping[status];
    if (enabledActions) {
      enabledActions.forEach((name) => {
        const action = out.find(a => a.action === name);
        if (action) {
          action.disabled = false;
        }
      });
    }
    return out;
  }
}

InquiryActions.REVIEW = 'review';
InquiryActions.RETURN_REVIEW = 'returnReview';
InquiryActions.CLOSE = 'close';
InquiryActions.ARCHIVE = 'archive';
InquiryActions.REOPEN = 'reopen';
InquiryActions.TRANSFER = 'transfer';
InquiryActions.DOWNLOAD = 'download';
InquiryActions.DELETE = 'delete';
InquiryActions.SAVE = 'save';
InquiryActions.SAVECLOSE = 'saveclose';
